module.exports = __webpack_public_path__ + "static/flags/WZ-0f1f9122ef057fb2f8644cbadfd50d66.gif";